import { render, staticRenderFns } from "./ChangeDetail.vue?vue&type=template&id=0c4026fe&scoped=true&"
import script from "./ChangeDetail.vue?vue&type=script&lang=js&"
export * from "./ChangeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4026fe",
  null
  
)

export default component.exports